import React from 'react'
import PropTypes from 'prop-types'
import {
  Box,
  Collapse,
  Tag,
  TagLabel,
  TagRightIcon,
  Text,
  useDisclosure,
} from '@chakra-ui/react'
import {ChevronDownIcon, ChevronUpIcon} from '@chakra-ui/icons'

const colorSchemeToBackground = {
  alert: 'mld.alert.200',
  warning: 'mld.warning.100',
  success: 'mld.success.100',
  info: 'mld.neutral.100',
  neutral: 'mld.neutral.500',
}

export const ExpandableTag = ({label, children, colorScheme}) => {
  const {isOpen, onToggle} = useDisclosure()
  const bg =
    colorSchemeToBackground[colorScheme] ?? colorSchemeToBackground.neutral

  return (
    <Box display="inline-block" position="relative">
      <Tag
        variant="status"
        colorScheme={colorScheme}
        as="button"
        onClick={onToggle}
        cursor="pointer"
        width="100%"
        borderBottomRadius={isOpen ? 0 : 'md'}
      >
        <TagLabel width="100%" textAlign="left">
          {label}
        </TagLabel>
        <TagRightIcon as={isOpen ? ChevronUpIcon : ChevronDownIcon} />
      </Tag>
      <Collapse
        in={isOpen}
        animateOpacity
        position="absolute"
        top="100%"
        left="0"
        minW="100%"
        zIndex="1"
      >
        <Box bg={bg} borderBottomRadius="md" px="xs" pb="xs">
          <Text
            textStyle="body-detail"
            color="mld.neutral.700"
            whiteSpace="normal"
          >
            {children}
          </Text>
        </Box>
      </Collapse>
    </Box>
  )
}

ExpandableTag.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  colorScheme: PropTypes.oneOf([
    'alert',
    'warning',
    'success',
    'info',
    'neutral',
  ]),
}

ExpandableTag.defaultProps = {
  colorScheme: 'neutral',
}
